import React, {PureComponent} from "react"

import PlaceholderBar from "@irati/ui/src/Placeholder"
import Flex from "@irati/ui/src/Flex"
import {IconCircle, Container, EmailHeaderLogo, HeaderSeparator} from "../styled"

interface Props {
  showCustomLogo: boolean,
  perkboxImageLink: string,
  customLogoLink: string
}

class Header extends PureComponent<Props> {
  render() {
    const {showCustomLogo, perkboxImageLink, customLogoLink} = this.props

    return (
      <>
        <PlaceholderBar type="dark" margin="0 0 30px 0" width="50%" />
        <Flex margin="0 0 30px 0">
          <IconCircle />

          <Container>
            <Flex justifyContent="space-between">
              <Flex>
                <PlaceholderBar width="50px" />
                <PlaceholderBar width="150px" margin="0 0 0 5px" />
              </Flex>
              <PlaceholderBar width="225px" margin="0 0 0 5px" />
            </Flex>
            <PlaceholderBar width="175px" />
          </Container>
        </Flex>
        <Flex justifyContent="center" alignItems="center" width="90%" margin="auto 0">
          <EmailHeaderLogo src={perkboxImageLink} />
          {showCustomLogo && (
            <>
              <HeaderSeparator />
              <EmailHeaderLogo src={customLogoLink} />
            </>
          )}
        </Flex>
      </>
    )
  }
}
export default Header
